if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.currentCounter = this.querySelector('[data-product-modal-current]');
        this.totalCounter = this.querySelector('[data-product-modal-total]');
        this.thumbnails = Array.from(this.querySelectorAll('[data-product-modal-thumbnail]'));
        this.touchStartX = 0;

        this.previousButton?.addEventListener('click', () => this.navigate(-1));
        this.nextButton?.addEventListener('click', () => this.navigate(1));
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            const mediaId = thumbnail.getAttribute('data-product-modal-thumbnail');
            const media = this.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`);
            if (media) this.showMedia(media);
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigate(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigate(1);
          }
        });
        /* Prevent Dawn's media-modal pointerup from closing when interacting with the slider. */
        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            if (
              event.target.closest(
                'img, button, deferred-media, product-model, .product-media-modal__header, .product-media-modal__thumbnails, .product-media-modal__nav, .product-media-modal__counter'
              )
            ) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.touchStartX = event.clientX;
        });
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' || !this.touchStartX) return;
          const distance = event.clientX - this.touchStartX;
          this.touchStartX = 0;
          if (Math.abs(distance) < 50) return;
          this.navigate(distance > 0 ? -1 : 1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        this.showMedia(activeMedia);
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      navigate(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        const activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('active')));
        const nextIndex = (activeIndex + direction + items.length) % items.length;
        this.showMedia(items[nextIndex]);
      }

      showMedia(activeMedia) {
        this.mediaItems.forEach((element) => element.classList.remove('active'));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const activeIndex = this.mediaItems.indexOf(activeMedia);
        if (this.currentCounter) this.currentCounter.textContent = activeIndex + 1;
        if (this.totalCounter) this.totalCounter.textContent = this.mediaItems.length;
        this.thumbnails.forEach((thumbnail) => {
          const isActive =
            thumbnail.getAttribute('data-product-modal-thumbnail') === activeMedia.getAttribute('data-media-id');
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
